import React from 'react';
import { State } from '..';
import { INotificationContext } from 'utils/NotificationManager';
import { KeysOfType } from 'component_utils/typescriptUtils';
import Translation from 'utils/Language/Translation';

interface EventProps {
  notifications: INotificationContext;
}

interface Config<S, P, A, R> {
  nextState: number;
  kardexBoxKey: KeysOfType<S, string>;
  attributes?: Partial<A>;
}

const StateKardex = function <S, P extends EventProps, A extends { hint: string }, R>({
  nextState,
  kardexBoxKey,
  attributes = {},
}: Config<S, P, A, R>): State<S, P, A, R> {
  return {
    onAction: async ({ props: { notifications }, inputs: [s] }) => {
      if (!/^K\d\d-\d\d-\d\d\+\d\d\d\d\d\d$/.test(s)) {
        throw notifications.add('danger', <Translation name="T.misc.wrongFormat" />);
      }

      return {
        type: 'MOVE',
        data: {
          [kardexBoxKey]: s,
        } as any,
        nextState,
      };
    },
    attributes: {
      hint: 'T.hints.kardexBox',
      ...(attributes as any),
    },

    nodeName: 'T.states.kardexBox',
    outputs: [
      {
        name: 'onScan',
        to: nextState,
      },
    ],
  };
};

export default StateKardex;
